import { QueryFunction, QueryKey, useQuery, UseQueryOptions } from "@tanstack/react-query";
import { App } from "antd";
import { handleError } from "api";
import { EventsParams, eventsQueryKeys, EventsResponse } from "features/events";

import { TransectionApiServices } from "../api/transection-api.service";

const { getInvoiceList } = TransectionApiServices();


const getEventsQuery = (
    flag: string,
    params: EventsParams,
    options?: UseQueryOptions<EventsResponse>,
): {
    queryKey: QueryKey;
    queryFn: QueryFunction<EventsResponse>;
    options?: UseQueryOptions<EventsResponse>;
} => ({
    queryKey: eventsQueryKeys.list(params),
    queryFn: ({ signal }) => getInvoiceList(flag, params, { config: { signal } }) as any,
    ...options,
});


export const useGetInvoiceList = (
    flag: string,
    params: EventsParams,
    options?: UseQueryOptions<EventsResponse>,
) => {
    const { message } = App.useApp();

    return useQuery<EventsResponse, Error>(
        getEventsQuery(flag, params, {
             onError: (error: unknown) => {
                const uiMessage = handleError(error);
                message.error(uiMessage);
            },
            onSuccess: (data) => {
                if (!data) {
                    message.error("No data found");
                }
            },
            ...options,
        }),
    );
};